import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useI18blogTabs } from "../../../../../hooks";

import TabsItem from "./components/TabsItem";

import { TabsList, TabsWrapper } from "./BlogTabs.styled";

const BlogTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentTab = searchParams.get("tab");

  useEffect(() => {
    if (!currentTab) {
      setSearchParams({ tab: "all" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const tabs = t("blog.tabs", { returnObjects: true });

  const { tabs } = useI18blogTabs();

  const handleClickTab = name => {
    setSearchParams({ tab: name, page: "1" });
  };

  return (
    <TabsWrapper>
      <TabsList>
        {tabs.map(({ name, title }) => (
          <TabsItem
            key={name}
            title={title}
            active={currentTab === name}
            onClick={() => handleClickTab(name)}
          />
        ))}
      </TabsList>
    </TabsWrapper>
  );
};

export default BlogTabs;
